(function () {
    'use strict';

    angular
        .module('app.shared')
        .constant('handicapCalculationResolver', {
            calculation: getCalculation,
        });

    getCalculation.$inject = ['Score', '$transition$', 'user'];
    function getCalculation(Score, $transition$, user) {
        var individualId = $transition$.params().individualId || user.id;
        return individualId ? Score.getHandicapCalculation({ individualId: individualId }).$promise : { scores: [], handicapScores: [] };
    }
})();